export default __webpack_public_path__ + "static/media/1-4-1.45e1f401.webp";